// @flow

import {Dom, Loc} from 'main.core';
import {Form} from './form';

export class FormGetPriceParts
{
	#app;
	#partsId = null; // Инициализация свойства для хранения id запчасти
	constructor(rootNode, partsId): void
	{
		this.rootNode = document.querySelector(rootNode);
		this.#partsId = partsId;
	}
	// Метод для установки id запчасти
	setPartsId(partsId): void
	{
		this.#partsId = partsId;
	}

	start(): void
	{
		this.attachTemplate();
	}
	attachTemplate(): void
	{
		this.#app = BX.Vue3.BitrixVue.createApp({
			components: {
				Form
			},
			template: `
				<div>
					<Form :parts-id="partsId"/>
				</div>
				`,
			data: () => ({
				partsId: this.#partsId // Передача id запчасти в данные компонента
			}),
		});
		this.#app.mount(this.rootNode);
	}
}
